// 在 main.js 或 main.ts 中
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/styles.css';
import './assets/css/main.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faCog, faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faUser, faCog, faHome);

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

const app = createApp(App);

// 加载用户的主题偏好
const savedTheme = localStorage.getItem('theme') || 'light';
document.documentElement.setAttribute('data-theme', savedTheme);

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.use(ElementPlus);
app.mount('#app');